<div class="enrollment-confirmation-page">
    <div class="content">
        <div class="portalLogo" (click)="gotoHome()" style="cursor: pointer;" title="Home"></div>
        <h2>{{ 'enrollmentConfirmation.title' | translate }}</h2>
        <p>{{ 'enrollmentConfirmation.message1' | translate }}
            <a [routerLink]="['/coverage']">{{ 'enrollmentConfirmation.here' | translate }}</a>{{ 'enrollmentConfirmation.message2' | translate }}</p>
        <button [routerLink]="['/coverage']" class="primary-button">
            {{ 'enrollmentConfirmation.viewAfpPage' | translate }}
        </button>
    </div>
</div>